// import React from "react";
// import ReactExport from "react-export-excel";
// import {
//     Button  
//   } from "@mui/material";
// import GetAppIcon from '@mui/icons-material/GetApp';

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

// const ReportExport = (props) => {
//     const { pccreportdataset } = props;
//         return (
//             <ExcelFile element={
//             <Button sx={{ mx: 1,
//                 width: '100 px',
//                 height: '30px',
//                 marginBottom:"20px",
//                 marginTop:"-15px",
//             }}
//             variant="contained"
//             startIcon={<GetAppIcon />}> LabDetails </Button>       
//             }>
//                 <ExcelSheet data={pccreportdataset} name="Lab Credentials">
//                     <ExcelColumn label="Trainee Name" value="trainee"  style={{ font: { sz: "24", bold: true } }}/>
//                     <ExcelColumn label="Server Name" value="key"/>
//                     <ExcelColumn label="Public Ip" value="public"/>
//                     <ExcelColumn label="Private Ip" value="private"/>
//                     <ExcelColumn label="Console url" value="console_url"/>
//                     <ExcelColumn label="Console username" value="console_username"/>
//                     <ExcelColumn label="Console password" value="console_password"/>
//                     <ExcelColumn label="Instance username" value="instance_username"/>
//                     <ExcelColumn label="Instance password" value="instance_password"/>
//                 </ExcelSheet>
//             </ExcelFile>
//         );
// }


// export default ReportExport;



import React from "react";
import ReactExport from "react-export-excel";
import { Button, Tooltip } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ReportExport = (props) => {
    const { pccreportdataset } = props;
    return (
        <Tooltip title="Lab Details" arrow>
            <span>
                <ExcelFile element={
                    <Button
                        sx={{
                            mx: 0.5,
                            height: { xs: "26px", sm: "30px" },
                            width: { xs: "26px", sm: "30px" },
                            minWidth: 'auto',
                            marginBottom: { xs: "3px", sm: "5px" },
                            marginTop: { xs: "-18px", sm: "-20px" },
                            borderRadius: '50px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            p: 0,
                        }}
                        variant="contained"
                        aria-label="download lab details"
                    >
                        <GetAppIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                    </Button>
                }>
                    <ExcelSheet data={pccreportdataset} name="Lab Credentials">
                        <ExcelColumn label="Trainee Name" value="trainee" style={{ font: { sz: "24", bold: true } }} />
                        <ExcelColumn label="Server Name" value="key" />
                        <ExcelColumn label="Public Ip" value="public" />
                        <ExcelColumn label="Private Ip" value="private" />
                        <ExcelColumn label="Console url" value="console_url" />
                        {/* <ExcelColumn label="Console username" value="console_username"/>
                            <ExcelColumn label="Console password" value="console_password"/> */}
                        <ExcelColumn label="Instance username" value="instance_username" />
                        <ExcelColumn label="Instance password" value="instance_password" />

                    </ExcelSheet>
                </ExcelFile>
            </span>
        </Tooltip>
    );
}


export default ReportExport;